<template>
    <div class="about-initiative-form8">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group
                label="Quais documentos sua iniciativa solicita para apoiar potências? (marque todas que se aplicam)"
                label-for="documents"
                class="required"
                v-if="getProfileId === 1"
            >
                <b-form-checkbox-group
                    id="documents"
                    name="documents"
                    v-model="$v.form.documents.selected.$model"
                    :options="form.documents.options"
                    value-field="item"
                    text-field="text"
                    :state="validateState('documents')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['doc_iniciativa_solicita'].value)
                    "
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['doc_iniciativa_solicita'].value"
                />

                <b-form-input
                    name="others"
                    class="col-md-6"
                    v-model="form.others"
                    placeholder="Especifique outros"
                    :disabled="getIsDisabled"
                    v-if="form.documents.selected.includes(23)"
                ></b-form-input>

                <b-form-invalid-feedback :state="validateState('documents')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Projetos aprovados por qual lei de incentivo sua iniciativa apoia?"
                label-for="approvedProjects"
                class="required"
                v-if="form.documents.selected.includes(18)"
            >
                <b-form-checkbox-group
                    id="approved-projects"
                    name="approvedProjects"
                    v-model="$v.form.approvedProjects.selected.$model"
                    :options="form.approvedProjects.options"
                    value-field="item"
                    text-field="text"
                    :state="validateState('approvedProjects')"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['projetos_aprovados'].value)
                    "
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['projetos_aprovados'].value"
                />

                <b-form-input
                    name="others"
                    class="col-md-6"
                    v-model="form.approvedProjectsOthers"
                    placeholder="Especifique outros"
                    :disabled="getIsDisabled"
                    v-if="form.approvedProjects.selected.includes(11)"
                ></b-form-input>

                <b-form-invalid-feedback :state="validateState('approvedProjects')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="
                        $router.push({
                            name: initiative.interesse_em_ppp.includes(11)
                                ? 'AboutInitiativeForm7'
                                : 'AboutInitiativeForm6'
                        })
                    "
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button
                        :variant="'secondary'"
                        @click="
                            changeRegisterForm(
                                initiative.interesse_em_ppp.includes(11)
                                    ? 'AboutInitiativeForm7'
                                    : 'AboutInitiativeForm6'
                            )
                        "
                        >Voltar</b-button
                    >

                    <b-button :variant="'primary'" @click="changeRegisterForm('AboutInitiativeForm9')">
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { AboutInitiativeApi } from '../../api/about-initiative'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const aboutInitiativeApi = new AboutInitiativeApi()

export default {
    components: { DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isDisabled: null,
            initiative: null,
            progress: 44.32,
            message: null,
            authorizationData: null,
            isUpdate: false,
            form: {
                documents: {
                    selected: [],
                    options: [
                        { text: 'Ata de Eleição da Atual Diretoria', item: 1, value: 1 },
                        { text: 'Ata de Fundação da organização e última atualização', item: 2, value: 2 },
                        { text: 'Auditoria externa', item: 3, value: 3 },
                        { text: 'Balanço Patrimonial do último exercício social', item: 4, value: 4 },
                        {
                            text:
                                'Carta elaborada e assinada pela potência, atestando que as atividades por ela desenvolvidas estão de acordo com as leis trabalhistas brasileiras',
                            item: 5,
                            value: 5
                        },
                        {
                            text:
                                'Certidão Conjunta de Débitos relativos aos Tributos Federais, Certidões negativa de débito trabalhista (CNDT) e regularidade com o FGTS',
                            item: 6,
                            value: 6
                        },
                        {
                            text: 'Certidão de isenção do Imposto de Transmissão Causa Mortis e Doação (ITCMD)',
                            item: 7,
                            value: 7
                        },
                        {
                            text:
                                'Certidões negativas de débitos fiscais (CND) nos âmbitos federal, estadual e municipal',
                            item: 8,
                            value: 8
                        },
                        { text: 'Comprovante de inscrição no CNPJ', item: 9, value: 9 },
                        {
                            text:
                                'Declaração do dirigente máximo acerca da inexistência de dívida com o poder público ou de inscrição da ORGANIZAÇÃO nos bancos de dados públicos ou privados de proteção ao crédito',
                            item: 10,
                            value: 10
                        },
                        {
                            text:
                                'Declaração, para fins do disposto no inciso V do art. 27 da lei nº 8.666, de 21 de junho de 1993, acrescido pela Lei nº 9.854, de 27 de outubro de 1999, de que não possui em seu quadro de pessoal empregado(s) com menos de 18 (dezoito) anos em trabalho noturno, perigoso ou insalubre e, em qualquer trabalho, menores de 16 (dezesseis) anos, salvo na condição de aprendiz a partir de 14 (quatorze) anos',
                            item: 11,
                            value: 11
                        },
                        { text: 'Demonstração do Resultado do Exercício – DRE', item: 12, value: 12 },
                        {
                            text:
                                'Documentação sobre parcerias (quando couber), tais como cartas de intenção, termos e/ou contratos de parceria. Essa documentação deve demonstrar a natureza da parceria (financeira, técnica, de recursos humanos, materiais e outros) e ser assinada pelos responsáveis legais de cada uma das entidades envolvidas',
                            item: 13,
                            value: 13
                        },
                        { text: 'Estatuto da Instituição', item: 14, value: 14 },
                        { text: 'Orçamento Físico-Financeiro', item: 15, value: 15 },
                        { text: 'Necessidade de apresentar orçamentos comparativos', item: 17, value: 17 },
                        { text: 'Projetos aprovados em leis de incentivo', item: 18, value: 18 },
                        {
                            text:
                                'Registro no respectivo Conselho Municipal dos Direitos da Criança e do Adolescente (exceto para aquelas organizações de Educação para o trabalho que atuem exclusivamente com jovens acima de 18 anos)',
                            item: 19,
                            value: 19
                        },
                        {
                            text: 'Resumo com o currículo (histórico de atuação) do responsável pelo projeto',
                            item: 20,
                            value: 20
                        },
                        { text: 'Vídeo da liderança se apresentando', item: 21, value: 21 },
                        { text: 'Cópia do CPF/RG dos atuais representantes legais/sócios', item: 24, value: 24 },
                        { text: 'Nenhum', item: 22, value: 22 },
                        { text: 'Outros (especifique)', item: 23, value: 23 }
                    ]
                },
                others: null,
                approvedProjects: {
                    selected: [],
                    options: [
                        { text: 'Lei Rouanet', item: 1, value: 1 },
                        { text: 'Lei do Audiovisual', item: 2, value: 2 },
                        { text: 'Programa de Ação Cultural', item: 3, value: 3 },
                        { text: 'Lei de Incentivo ao Esporte', item: 4, value: 4 },
                        { text: 'PRONON - Programa Nacional de Oncologia', item: 5, value: 5 },
                        { text: 'PRONAS - Programa Nacional de Acessibilidade', item: 6, value: 6 },
                        { text: 'FIA – Fundo dos Direitos da Criança e do Adolescente', item: 7, value: 7 },
                        { text: 'Fundo Municipal do Idoso', item: 8, value: 8 },
                        { text: 'PROAC', item: 9, value: 9 },
                        { text: 'PROMAC', item: 10, value: 10 },
                        { text: 'Outros (especifique)', item: 11, value: 11 }
                    ]
                },
                approvedProjectsOthers: null
            }
        }
    },
    validations: {
        form: {
            documents: {
                selected: {
                    required() {
                        return !(!this.form.documents.selected.length && this.getProfileId === 1)
                    }
                }
            },
            approvedProjects: {
                selected: {
                    required() {
                        return !(
                            this.form.approvedProjects.selected.length === 0 &&
                            this.form.documents.selected.includes(18)
                        )
                    }
                }
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress', 'setShowGamificationProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData
            this.initiative = data

            this.form.documents.selected =
                data.doc_iniciativa_solicita === null
                    ? []
                    : data.doc_iniciativa_solicita.filter(item => typeof item === 'number')

            this.form.others =
                data.doc_iniciativa_solicita === null
                    ? null
                    : data.doc_iniciativa_solicita.filter(item => typeof item !== 'number')[0].others

            this.form.approvedProjects.selected =
                data.projetos_aprovados === null ? [] : data.projetos_aprovados.filter(item => typeof item === 'number')

            this.form.approvedProjectsOthers =
                data.projetos_aprovados === null
                    ? null
                    : data.projetos_aprovados.filter(item => typeof item !== 'number')[0].approvedProjectsOthers

            this.filterData()
            this.fetchAuthorization()
        },
        fetch() {
            if (this.getProgress === '41.55') {
                this.setShowGamificationProgress(true)

                setTimeout(() => {
                    this.setShowGamificationProgress(false)
                }, 12000)
            }

            this.setIsLoading(true)

            axios
                .all([aboutInitiativeApi.getAboutInitiative()])
                .then(response => {
                    const data = response[0].data.data
                    if (data !== null) {
                        this.initiative = data

                        this.form.documents.selected =
                            data.doc_iniciativa_solicita === null
                                ? []
                                : data.doc_iniciativa_solicita.filter(item => typeof item === 'number')

                        this.form.others =
                            data.doc_iniciativa_solicita === null
                                ? null
                                : data.doc_iniciativa_solicita.filter(item => typeof item !== 'number')[0].others

                        this.form.approvedProjects.selected =
                            data.projetos_aprovados === null
                                ? []
                                : data.projetos_aprovados.filter(item => typeof item === 'number')

                        this.form.approvedProjectsOthers =
                            data.projetos_aprovados === null
                                ? null
                                : data.projetos_aprovados.filter(item => typeof item !== 'number')[0]
                                      .approvedProjectsOthers
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress
            const data = {
                ...this.initiative,
                doc_iniciativa_solicita: this.form.documents.selected,
                projetos_aprovados: this.form.approvedProjects.selected,
                percentual: currentProgress
            }

            data.doc_iniciativa_solicita = [...data.doc_iniciativa_solicita, { others: this.form.others }]

            data.projetos_aprovados = [
                ...data.projetos_aprovados,
                { approvedProjectsOthers: this.form.approvedProjectsOthers }
            ]

            this.setIsLoading(true)
            const request = this.isUpdate
                ? aboutInitiativeApi.updateAboutInitiative(data)
                : aboutInitiativeApi.nextAboutInitiative(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)

                    if (this.isUpdate) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.$router.push({ name: 'AboutInitiativeForm9' })
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getAboutInitiative(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        filterData() {
            if (this.receiveData) {
                this.form.documents.options = this.form.documents.options.filter(x =>
                    this.form.documents.selected.includes(x.value)
                )

                this.form.approvedProjects.options = this.form.approvedProjects.options.filter(x =>
                    this.form.approvedProjects.selected.includes(x.value)
                )
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getProgress() {
            return this.$store.state.progress
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getAuthorizationData() {
            return this.authorizationData
        },
        getProfileId() {
            return this.$store.state.profileId
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./AboutInitiativeForm8-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-about-initiative-forms/AboutInitiativeForm8.vue